export default __webpack_public_path__ + "static/media/plate_glass.597b86fd.svg";